// @flow

import { observer } from "mobx-react";
import React from "react";

import "./VideoProgressRangeBoundary.scss";

type Props = {
    active: boolean
};

@observer
export default class VideoProgressRangeBoundary extends React.Component<Props> {
    render() {
        const classes = ["VideoProgressRangeBoundary"];
        if (this.props.active) {
            classes.push("VideoProgressRangeBoundary--active");
        }

        return <div className={classes.join(" ")} />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoProgressRangeBoundary/VideoProgressRangeBoundary.js